import { ChangeDetectionStrategy, Component, computed, effect, input, model, untracked } from "@angular/core";
import { IDepartment } from "@shared/bedside-shift-report/models/department";
import { IFacility } from "@shared/bedside-shift-report/models/facility";
import { IFacilityAndDepartmentSelectorConfig } from "@shared/components/facility-and-department-selector/facility-and-department-selector-config";

@Component({
    selector: "app-facility-and-department-selector",
    templateUrl: "./facility-and-department-selector.component.html",
    styleUrl: "./facility-and-department-selector.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacilityAndDepartmentSelectorComponent {
    public config = input<IFacilityAndDepartmentSelectorConfig | null>(null);
    public facilities = input.required<IFacility[]>();
    public departments = input.required<IDepartment[]>();
    public selectedFacility = model<IFacility | null>(null);
    public selectedDepartment = model<IDepartment | null>(null);

    public filteredDepartments = computed(() => {
        const departments = this.departments();
        const selectedFacility = this.selectedFacility();

        if (!selectedFacility) return departments;

        return departments.filter((department) => department.facilityId === selectedFacility.id);
    });

    constructor() {
        effect(() => {
            const facility = this.selectedFacility();
            const department = this.selectedDepartment();
            untracked(() => {
                if (!facility) return;
                const doesSelectedDepartmentMatchFacility = department?.facilityId === facility.id;

                if (!doesSelectedDepartmentMatchFacility) {
                    this.selectedDepartment.set(null);
                }
            });
        });

        effect(() => {
            const facility = this.selectedFacility();
            const department = this.selectedDepartment();
            untracked(() => {
                if (!facility) {
                    const matchingFacility =
                        this.facilities().find((facility) => facility.id === department?.facilityId) ?? null;
                    this.selectedFacility.set(matchingFacility);
                }
            });
        });
    }
}
